"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcProviderError = void 0;
class OidcProviderError extends Error {
    constructor(message, error, errorDescription) {
        super(message);
        this.error = error;
        this.errorDescription = errorDescription;
    }
}
exports.OidcProviderError = OidcProviderError;
//# sourceMappingURL=OidcProviderError.js.map